import React from "react";
import { Page } from "components/common";
import { compose } from "recompose";
import { Trans } from "react-i18next";

export const PrivacyPolicy = () => (
  <Page title="Privacy Policy" className="privacy-policy">
    <p><Trans>Last updated: December 12, 2024</Trans></p>
    <p>
      <Trans>
        Wealth Preservation Holding Company ("us", "we", or "our") operates the{" "}
        <a href="https://hesaab.app" target="_blank" rel="noopener noreferrer"> https://hesaab.app</a>{" "}
        website (the "Service").
      </Trans>
    </p>

    <p>
     <Trans> 
        This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.
      </Trans>
    </p>

    <p>
      <Trans>We will not use or share your information with anyone except as described in this Privacy Policy.</Trans>
    </p>

    <p>
      <Trans>
        We use your Personal Information for providing and improving the Service.
        By using the Service, you agree to the collection and use of information
        in accordance with this policy. Unless otherwise defined in this Privacy
        Policy, terms used in this Privacy Policy have the same meanings as in our
        Terms and Conditions, accessible at <a href="https://hesaab.wpholding.com" target="_blank" rel="noopener noreferrer">https://hesaab.wpholding.com</a>
      </Trans>
    </p>

    <div className="mt-5">
      <h5><Trans>Information Collection And Use</Trans></h5>

      <p>
       <Trans>
        While using our Service, we may ask you to provide us with certain
        personally identifiable information that can be used to contact or
        identify you. Personally identifiable information may include, but is
        not limited to, your email address, name, phone number, postal address,
        other information ("Personal Information").
       </Trans>
      </p>
    </div>

    <div className="mt-5">
      <h5><Trans>Log Data</Trans></h5>

      <p>
        <Trans>
        We may also collect information that your browser sends whenever you
        visit our Service ("Log Data"). This Log Data may include information
        such as your computer's Internet Protocol ("IP") address, browser type,
        browser version, the pages of our Service that you visit, the time and
        date of your visit, the time spent on those pages and other statistics.
        </Trans>
      </p>
    </div>

    <div className="mt-5">
      <h5><Trans>Cookies</Trans></h5>

      <p>
        <Trans>
          Cookies are files with small amount of data, which may include an
          anonymous unique identifier. Cookies are sent to your browser from a web
          site and stored on your computer's hard drive.
        </Trans>
      </p>

      <p>
        <Trans>
          We use "cookies" to collect information. You can instruct your browser
          to refuse all cookies or to indicate when a cookie is being sent.
          However, if you do not accept cookies, you may not be able to use some
          portions of our Service.
        </Trans>
      </p>
    </div>

    <div className="mt-5">
      <h5><Trans>Service Providers</Trans></h5>

      <p>
        <Trans>  
          We may employ third party companies and individuals to facilitate our
          Service, to provide the Service on our behalf, to perform
          Service-related services or to assist us in analyzing how our Service is
          used.
        </Trans>
      </p>

      <p>
       <Trans>
          These third parties have access to your Personal Information only to
          perform these tasks on our behalf and are obligated not to disclose or
          use it for any other purpose.
        </Trans>
      </p>
    </div>

    <div className="mt-5">
      <h5><Trans>Security</Trans></h5>
      <p>
        <Trans>
          The security of your Personal Information is important to us, but
          remember that no method of transmission over the Internet, or method of
          electronic storage is 100% secure. While we strive to use commercially
          acceptable means to protect your Personal Information, we cannot
          guarantee its absolute security.
        </Trans>
      </p>
    </div>

    <div className="mt-5">
      <h5><Trans>International Transfer</Trans></h5>

      <p>
        <Trans>
        Your information, including Personal Information, may be transferred to
        — and maintained on — computers located outside of your state, province,
        country or other governmental jurisdiction where the data protection
        laws may differ than those from your jurisdiction.
        </Trans>
      </p>

      <p>
        <Trans>
          If you are located outside Saudi Arabia and choose to provide
          information to us, please note that we transfer the information,
          including Personal Information, to Saudi Arabia and process it there.
        </Trans>
      </p>

      <p>
        <Trans>
          Your consent to this Privacy Policy followed by your submission of such
          information represents your agreement to that transfer.
        </Trans>
      </p>
    </div>

    <div className="mt-5">
      <h5><Trans>Links To Other Sites</Trans></h5>

      <p>
       <Trans>
        Our Service may contain links to other sites that are not operated by
        us. If you click on a third party link, you will be directed to that
        third party's site. We strongly advise you to review the Privacy Policy
        of every site you visit.
       </Trans>
      </p>

      <p>
        <Trans>
          We have no control over, and assume no responsibility for the content,
          privacy policies or practices of any third party sites or services.
        </Trans>
      </p>
    </div>

    <div className="mt-5">
      <h5><Trans>Children's Privacy</Trans></h5>

      <p>
        <Trans>Our Service does not address anyone under the age of 13 ("Children").</Trans>
      </p>

      <p>
        <Trans>
          We do not knowingly collect personally identifiable information from
          children under 13. If you are a parent or guardian and you are aware
          that your Children has provided us with Personal Information, please
          contact us. If we become aware that we have collected Personal
          Information from a child under age 13 without verification of parental
          consent, we take steps to remove that information from our servers.
        </Trans>
      </p>
    </div>

    <div className="mt-5">
      <h5><Trans>Changes To This Privacy Policy</Trans></h5>

      <p>
       <Trans>
        We may update our Privacy Policy from time to time. We will notify you
        of any changes by posting the new Privacy Policy on this page.
       </Trans>
      </p>

      <p>
       <Trans>
        You are advised to review this Privacy Policy periodically for any
        changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
       </Trans>
      </p>
    </div>

    <div className="mt-5">
      <h5><Trans>Contact Us</Trans></h5>

      <p>
        <Trans>If you have any questions about this Privacy Policy, please contact us.</Trans>
      </p>
    </div>
  </Page>
);

const enhance = compose();

export default enhance(PrivacyPolicy);
